module.exports = __webpack_public_path__ + "static/img/anon_profile.e32066c.png";


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/anon_profile.png
// module id = 5EEx
// module chunks = 0